import { Injectable } from '@angular/core';
import { swErrorMessage } from '../../shared/constant/customer-journey/error-message-constant';
import { ValidationUiService } from '../../shared/service/ui/validation-ui';
import { Utils } from '../../shared/Utils/Utils';
import { DateOptionModel } from '../models/date-option.model';
import { ValidDateOption } from '../models/valid-date-option.model';

@Injectable({
  providedIn: 'root'
})
export class SectionWiseValidationService {
  constructor(private validationUiService: ValidationUiService) {}

  getValidDateOption(dateOption: DateOptionModel, minDate: Date, maxDate: Date, isPolicyRealDate?: boolean): ValidDateOption {
    const validDateOption = new ValidDateOption();

    if ((dateOption.day === 0 || dateOption.day == null) && (dateOption.month === 0 || dateOption.month == null) && (dateOption.year === 0 || dateOption.year == null)) {
      validDateOption.errorMessage = swErrorMessage.invalidDate;
      validDateOption.isValidDate = false;
    } else if (dateOption.day === 0 || dateOption.day == null) {
      validDateOption.isValidDay = false;
    } else if (dateOption.month === 0 || dateOption.month == null) {
      validDateOption.isValidMonth = false;
    } else if (dateOption.year === 0 || dateOption.year == null || dateOption.year < new Date().getFullYear() - 90) {
      validDateOption.isValidYear = false;
    } else if (this.validationUiService.isValidDate(Utils.getDateString(dateOption))) {
      const dateObj = new Date(Utils.getDateString(dateOption));

      if (dateObj < minDate) {
        validDateOption.isValidDate = false;
        validDateOption.errorMessage = swErrorMessage.invalidDate;
      } else if (dateObj > maxDate) {
        validDateOption.isValidDate = false;
        validDateOption.errorMessage = isPolicyRealDate ? swErrorMessage.invalidMaxRenewalDate : swErrorMessage.invalidDate;
      } else {
        validDateOption.isValidDate = true;
      }
    } else {
      validDateOption.isValidDate = false;
      validDateOption.errorMessage = swErrorMessage.invalidYear;
    }

    return validDateOption;
  }
}
